// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as MenuRouteImport } from './routes/menu'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as CartRouteImport } from './routes/cart'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as IndexRouteImport } from './routes/index'

const ProfileRoute = ProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => rootRouteImport
          })
const MenuRoute = MenuRouteImport.update({
            id: '/menu',path: '/menu',getParentRoute: () => rootRouteImport
          })
const CheckoutRoute = CheckoutRouteImport.update({
            id: '/checkout',path: '/checkout',getParentRoute: () => rootRouteImport
          })
const CartRoute = CartRouteImport.update({
            id: '/cart',path: '/cart',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthRoute: AuthRoute,CartRoute: CartRoute,CheckoutRoute: CheckoutRoute,MenuRoute: MenuRoute,ProfileRoute: ProfileRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)